<ftr-page-layout class="user" name="user" [bodyTemplate]="body" [entity]="viewModel" (onRetry)="triggerRefresh()">
  <ng-template #body let-viewModel>
    <h1>{{ viewModel.user | ftrUserName }} Profile</h1>
    <div class="profile__menu">
      <ftr-action-dropdown-menu
        ariaLabel="Account profile dropdown menu"
        [menuItems]="navItems$"
      ></ftr-action-dropdown-menu>
    </div>

    <ftr-user-profile-details [user]="viewModel.user"></ftr-user-profile-details>
    <br />
    <hr />
    <div class="user__groups">
      <h3>Groups and Permissions</h3>
      <p>This user can access:</p>

      @if (courtSystemId | async; as courtSystem) {
        <ftr-user-group-permissions-list
          [userGroups]="viewModel.user.groups"
          [courtSystemId]="courtSystem"
          [enabledRestrictions]="viewModel.enabledRestrictions"
          [rootLocations]="viewModel.rootLocations"
          [departments]="viewModel.departments"
        ></ftr-user-group-permissions-list>
      }

      <ftr-user-profile-groups-list
        (onSave)="triggerRefresh()"
        [courtSystemUser]="viewModel.user"
      ></ftr-user-profile-groups-list>
    </div>
  </ng-template>
</ftr-page-layout>
